<template>
  <div>
    <div v-if="user.van_or_bike === 'bike' && user.committed_volume > 260 && emailSent !== 'true'" class="bg-[#D9F3D0] border border-solid border-grey-light rounded-lg sm:p-7 p-5 h-full">
      <div v-if="updatesLoading" class="card-loader"></div>
      <template v-else>
        <p class="text-2xl font-medium text-black mb-4">{{$t('Great News - You Qualify for Van Pickups!')}}</p>
        <div class="text-black mb-4 whitespace-normal overflow-hidden">
          <p class="mb-4">{{$t('With Van Pickups, you can ship unlimited orders every single day')}}</p>
          <p>{{$t('Unlike the standard pickup service, which may sometimes be limited to 10 shipments per pickup depending on demand in your area, Van Pickups give you complete flexibility')}}</p>
          <p>{{$t('Ready to get started? Just let us know and we’ll set you up!')}}</p>
        </div>
          <div class="flex justify-end mt-6">
            <shipblu-button size="large" :textButton="$t('Apply')" @click="sendEmail('van_upgrade')" />
          </div>
      </template>
    </div>

    <div v-else-if="user.van_or_bike === null && emailSent !== 'true'" class="bg-[#FFFCD9] border border-solid border-grey-light rounded-lg sm:p-7 p-5 h-full">
      <div v-if="updatesLoading" class="card-loader"></div>
      <template v-else>
        <p class="text-2xl font-medium text-black mb-4">{{$t('Pick-Up Service Coming Soon!')}}</p>
        <div class="text-black mb-4 whitespace-normal overflow-hidden">
          <p>{{$t('Unfortunately, we don’t yet offer pickup service from your selected location')}}</p>
          <p>{{$t('But no worries - you can easily drop off your shipments anytime at the nearest ShipBlu location')}}</p>
          <p>{{$t('We’re constantly growing our network and adding new pickup points, so expect to see your area covered very soon!')}}</p>
        </div>
          <div class="flex justify-end mt-6">
            <shipblu-button size="large" :textButton="$t('Find out more')" @click="sendEmail('non_bike_zone')" />
          </div>
      </template>
    </div>

    <div v-else class="bg-white border border-solid border-grey-light rounded-lg sm:p-7 p-5 h-full">
      <div v-if="updatesLoading" class="card-loader"></div>
      <template v-else>
        <p :class="`text-sm opacity-75 ${$i18n.locale === 'en' ? 'tracking-widest' : ''}`">{{ $t('LATEST ANNOUNCEMENTS') }}</p>
        <div class="md:mt-6 mt-5 md:text-lg flex flex-col gap-3 sm:mr-[-21px] mr-[-14px] sm:pr-5 pr-3 xl:max-h-[160px] max-h-[200px] overflow-y-auto">
          <div v-for="update in updates" :key="update.id" class="flex md:gap-6 gap-3 items-start">
            <p class="opacity-75 whitespace-nowrap">{{ update.date }}</p>
            <p class="text-black">
              {{ $i18n.locale === 'en' ? update.en_text : update.ar_text }}
              <a class="underline" style="word-break: break-word;" :href="update.link_url" target="_blank">{{ $i18n.locale === 'en' ? update.en_link_text : update.ar_link_text }}</a>
            </p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { sendRequest } from '../../../http/axios/requestHelper'

export default {
  props: ['user'],
  data () {
    return {
      updates: [],
      updatesLoading: false,
      emailSent: ''
    }
  },
  methods: {
    loadUpdates () {
      this.updatesLoading = true
      sendRequest(false, false, this, 'api/v1/announcements/?limit=5', 'get', null, true, 
        (response) => {
          this.updates = response.data.results
          this.updatesLoading = false
        })
    },
    sendEmail (type) {
      sendRequest(false, false, this, `api/v1/merchants/${this.user.id}/auto-pickup-email/`, 'post', {email_type : type}, true,
        () => {
          localStorage.setItem('email_sent', true)
          this.emailSent = 'true'
        }
      )
    }
  },
  created () {
    this.loadUpdates()
    this.emailSent = localStorage.getItem('email_sent')
  }
}
</script>